import type { BaseInstance, ModelName } from '@pigello/pigello-matrix';
import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { QUERY_KEYS } from '../constants';
import type { ErrorResponse, useCreateGenericInstanceProps } from '../types';

export const useCreateGenericInstance = <Instance extends BaseInstance>(
  mutationFn: (
    options: useCreateGenericInstanceProps<Instance>
  ) => Promise<Instance>,
  options: UseMutationOptions<Instance, ErrorResponse, unknown, unknown>,
  modelName: ModelName
) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn,
    onSuccess: async (data, variables, onMutateResult, context) => {
      await Promise.all([
        options.onSuccess?.(data, variables, onMutateResult, context),
        queryClient.invalidateQueries({
          queryKey: [modelName, data.id],
        }),
        queryClient.invalidateQueries({
          queryKey: [modelName, QUERY_KEYS.LIST],
        }),
        queryClient.invalidateQueries({
          queryKey: [modelName, QUERY_KEYS.ALL_INSTANCES],
        }),
        queryClient.invalidateQueries({
          queryKey: [modelName, QUERY_KEYS.ALL_IDS],
        }),
        queryClient.invalidateQueries({
          queryKey: [modelName, QUERY_KEYS.COUNT],
        }),
      ]);
    },
  });
};
